var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import icons from "../../utils/Icons";
import axios from "axios";
import { useSelector } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
var PostCommentsModal = function (_a) {
    var _b;
    var post = _a.post, closeModal = _a.closeModal, updatePost = _a.updatePost;
    var closeModalHandle = function () {
        closeModal();
    };
    var _c = useState([]), comments = _c[0], setComments = _c[1];
    var _d = useState({
        comment: "",
    }), formData = _d[0], setFormData = _d[1];
    var userId = useSelector(function (state) { return state.user.userId; });
    var getUserImage = function (public_id) {
        if (public_id) {
            return "https://res.cloudinary.com/chaseit1416/image/upload/c_crop,g_face,h_400,r_max,w_400/c_scale,w_50/".concat(public_id);
        }
    };
    useEffect(function () {
        if (post.id) {
            fetchPosts(post.id);
        }
    }, [post]);
    var fetchPosts = function (post_id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("comments/list/" + post.id)];
                case 1:
                    response = _b.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.comments) {
                        setComments(response.data.comments);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.log(error_1.message);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var formDataHandle = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[name] = value, _a)));
    };
    var submitCommentHandle = function (e) {
        axios
            .post("comments/save", {
            post_id: post.id,
            user_id: userId,
            comment: formData.comment,
        })
            .then(function (response) {
            console.log(response.data);
            setComments(response.data.post.comments);
            setFormData(__assign(__assign({}, formData), { comment: "" }));
            updatePost(response.data.post);
        })
            .catch(function (error) {
            console.log(error);
        });
    };
    return (_jsx("div", { className: "bg-[#1c1c1d99] min-h-screen absolute top-0 right-0 bottom-0 left-0 z-20 justify-center lg:px-10 px-3", children: _jsxs("div", { className: "bg-white mt-[30px] relative w-full lg:mx-auto rounded-xl border-slate-300 p-4 opacity-100", children: [_jsx("button", { onClick: function () { return closeModalHandle(); }, className: "text-slate-700 absolute top-[10px] right-[10px]", children: _jsx("img", { src: icons.closeBlack, alt: "" }) }), _jsxs("div", { className: "text-start mt-2", children: [_jsxs("h2", { children: ["All comments (", comments === null || comments === void 0 ? void 0 : comments.length, ")"] }), comments.length > 0 ? (_jsx("div", { className: "overflow-y-scroll min-h-[300px]", children: comments.map(function (comment, index) {
                                return (_jsx("div", { className: "", children: comment.users && (_jsxs("div", { className: "flex gap-3 items-center justify-start my-4", children: [_jsx("div", { className: "w-[8%]", children: _jsx("div", { className: "w-[50px] h-[50px] overflow-hidden rounded-[50px]", children: _jsx("img", { width: "100%", src: getUserImage(comment.users
                                                            .public_id), alt: "" }) }) }), _jsxs("div", { className: "w-[88%] ml-[4%] capitalize bg-slate-200 rounded-lg text-md pl-4", children: [_jsx("span", { className: "text-[18px] mb-3 font-bold", children: comment.users.name }), _jsx("p", { children: comment.comment })] })] })) }, index));
                            }) })) : (_jsx("div", { children: _jsx("div", { className: "p-4", children: _jsx("p", { className: "text-lg font-semibold text-center py-6", children: "No Comments Found :-(" }) }) }))] }), _jsx("div", { children: _jsx("div", { className: "flex gap-1 items-start justify-between bg-slate-200 rounded-lg", children: _jsxs("div", { className: "flex items-center flex-1", children: [_jsx("textarea", { name: "comment", className: "bg-slate-200 w-full rounded-lg border-0 outline-0 px-4 py-1", onChange: formDataHandle, value: formData.comment, placeholder: "Enter something...", id: "" }), _jsx("button", { onClick: submitCommentHandle, disabled: ((_b = formData.comment) === null || _b === void 0 ? void 0 : _b.length) <= 0, className: "mx-2", children: _jsx(SendIcon, {}) })] }) }) })] }) }));
};
export default PostCommentsModal;
